import React from "react";
import "./Header.scoped.scss";
import LogoZapNew from "assets/images/zap manager-horizontal.png";
import accessibilityImg from "assets/images/accessibility.svg";
import { Link } from "raviger";
import { setIsMobileMenuOpen } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";
import * as TagManager from "core/common/seo/tagManager";
import LoaderBar from "./../../AjaxLoaders";

const Header = ({ isPreAuthentication,isActive,isRRH }) => {
    const { dispatch } = useStore();

    const renderAuthenticationOnly = () => {
        if (isPreAuthentication) {
            return null;
        }

        return (
            <>
                <div className="logo" id="logo">
                    <Link href="/home">
                        <img src={LogoZapNew} alt="logo" />
                    </Link>
                </div>
                {!isActive ? (
                 <h1 className="customer_is_active_text"> </h1>
                ) : isRRH ? (
                   <h1 className="customer_is_rrh_text"> </h1>
                ) : null}

                <div className="header_icon_wrap d-flex align-center">

                    <ul className="d-flex align-center">

                        <li className="accessibility">
                            <a
                                href="/"
                                onClick={(e) => {
                                    e.preventDefault();
                                    const accessibilityMenu = document.querySelector(
                                        ".accessibility-menu"
                                    );
                                    const isOpen = accessibilityMenu.style.display === "block";
                                    document.getElementById("OpenAccessibilityBtn").click();
                                    accessibilityMenu.style.display = isOpen ? "none" : "block";
                                    TagManager.sendGoogleEvent({
                                        category: "accessibility widget",
                                        action: "click on accessibility button",
                                    });
                                }}
                            >

                                <img src={accessibilityImg} alt="accessibilityImg" className={`${!isActive || isRRH ? 'accessibility_not_active': '' }`}/>
                            </a>
                        </li>
                    </ul>

                    <div className="menu_ hamburger_icon only_mobile_view">
                        <button
                            type="button"
                            id="hamburger-menu"
                            className="menu_bar"
                            onClick={(e) => {
                                e.stopPropagation();
                                dispatch(setIsMobileMenuOpen(true));
                            }}
                        >
                            <span />
                            <span />
                            <span />
                        </button>
                    </div>
                </div>
            </>
        );
    };

    return (
        
        <div className={`header_container ${!isActive || isRRH ? 'customer_not_active' : ''}`}>  
            <LoaderBar />        
            <div className="header_area">
                <div className="header_wrap center-content">
                    <div className="header_box d-flex align-center">
                        {renderAuthenticationOnly()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
